import { Dispatch, SetStateAction } from 'react';
import { constant } from 'src/js/util/constant';
import { useLocalStorage } from 'usehooks-ts';

export interface StreamPreferenceTypes {
  hideSlidingPanel?: boolean;
  favorite?: boolean; // TODO NKE-2065
}

export enum StreamPreferenceEnum {
  hideSlidingPanel = 'hideSlidingPanel',
  favorite = 'favorite',
}

export class StreamPreference {
  protected username: string;
  protected uuid: string | number;

  constructor(uuid: string | number, username: string) {
    this.uuid = uuid;
    this.username = username;
  }
  /*
use the return set function from useStreamPreference()
public set(key: StreamPreferenceEnum, value: any) {
  
}
*/
  public useStreamPreference<T>(key: StreamPreferenceEnum, initialValue: T): [T, Dispatch<SetStateAction<T>>] {
    return useLocalStorage<T>(
      `${constant.lStorage.streamPreference}:${this.username}:${key}:${this.uuid}`,
      initialValue,
    );
  }

  public clear(item: StreamPreferenceEnum) {
    const key = `${constant.lStorage.streamPreference}:${this.username}:${item}`;
    Object.keys(localStorage)
      .filter((x) => x.startsWith(key))
      .forEach((x) => {
        localStorage.removeItem(x);
      });
  }
}
